import { AirportLookupModel } from '../../model/airport-lookup.model';

export const getUpdateSearchedCities = (data, odPairLookUp, fromDest) => {
  const citiesAttributes: AirportLookupModel[] = [];
  if (data && data.listOfCities) {
    for (const searchItem of data.listOfCities) {
      if (odPairLookUp === 'true' && fromDest !== '') {
        citiesAttributes.push(
          new AirportLookupModel(
            searchItem.airportCode,
            searchItem.cityName,
            searchItem.region,
            searchItem.countryCode,
            searchItem.airportFullName,
            searchItem.airportName,
            searchItem.countryCode,
            searchItem.aliases,
            searchItem.attributes
          )
        );
      } else {
        citiesAttributes.push(
          new AirportLookupModel(
            searchItem.airportCode,
            searchItem.cityName,
            searchItem.region,
            searchItem.countryCode,
            searchItem.airportFullName,
            searchItem.airportName,
            searchItem.countryCode,
            searchItem.aliases,
            null
          )
        );
      }
    }
  }
  return citiesAttributes;
};

export const getCitiesValues = (data) => {
  const citiesAttributes: AirportLookupModel[] = [];
  for (const searchItem of data) {
    const airportFullName =
      searchItem.AIRPORT_NAME +
      ', ' +
      searchItem.COUNTRY +
      ' (' +
      searchItem.CITY_CODE +
      ')';
    const cityServe = searchItem.CITY_SERVE_LOWERCASE || '';
    let cityServeAlias: String[] = [];
    if (cityServe) {
      cityServeAlias = cityServe.split('/');
    }
    citiesAttributes.push(
      new AirportLookupModel(
        searchItem.AIRPORT_CODE,
        searchItem.CITY_NAME,
        searchItem.COUNTRY,
        searchItem.COUNTRY_CD,
        airportFullName,
        searchItem.AIRPORT_NAME,
        searchItem.CITY_CODE,
        cityServeAlias,
        null
      )
    );
  }
  return citiesAttributes;
};
